var ServiceDetailsData = React.createContext({});
export var ServiceDetailsDataProvider = ServiceDetailsData.Provider;
export var ServiceDetailsDataConsumer = ServiceDetailsData.Consumer;
export default ServiceDetailsData;